var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ant-design:disconnect-outlined"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.5143 4.48516C17.5314 2.50234 14.3229 2.50234 12.3424 4.48516L10.0713 6.75625L11.2666 7.95156L13.5377 5.68047C14.7986 4.41953 16.9268 4.28594 18.3189 5.68047C19.7135 7.075 19.5799 9.20078 18.3189 10.4617L16.0479 12.7328L17.2455 13.9305L19.5166 11.6594C21.4947 9.67656 21.4947 6.46797 19.5143 4.48516ZM10.465 18.318C9.2041 19.5789 7.07598 19.7125 5.68379 18.318C4.28926 16.9234 4.42285 14.7977 5.68379 13.5367L7.95488 11.2656L6.75723 10.068L4.48613 12.3391C2.50332 14.3219 2.50332 17.5305 4.48613 19.5109C6.46895 21.4914 9.67754 21.4938 11.658 19.5109L13.9291 17.2398L12.7338 16.0445L10.465 18.318ZM6.10098 4.90703C6.06574 4.87214 6.01815 4.85256 5.96855 4.85256C5.91896 4.85256 5.87137 4.87214 5.83613 4.90703L4.90801 5.83516C4.87311 5.8704 4.85354 5.91799 4.85354 5.96758C4.85354 6.01717 4.87311 6.06476 4.90801 6.1L17.9018 19.0938C17.9744 19.1664 18.0939 19.1664 18.1666 19.0938L19.0947 18.1656C19.1674 18.093 19.1674 17.9734 19.0947 17.9008L6.10098 4.90703Z",
    fill: "#E36C6C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnect);
export default __webpack_public_path__ + "static/media/disconnect.7e59d8327e03cec888d0426d2a182035.svg";
export { ForwardRef as ReactComponent };